//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
export default {
  name: 'SingleWebCoin',
  props: {
    coin: {
      type: Object,
      default: null
    },
    price: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      marketPrice: null
    }
  },
  computed: {
    ...mapGetters({
      getSymbolFaName: 'coins/getSymbolFaName',
      buyDollarPrice: 'coins/buyDollarPrice',
      assets: 'coins/assets',
      watchList: 'watchList/watchList',
      latest: 'coins/latest',
      isGuest: 'auth/isGuest'
    }),
    logoSrc () {
      return '../../../static/images/logo/' + this.coin.base + '.svg'
    },
    isUsdtIrt () {
      return String(this.coin && this.coin.symbol).toUpperCase() === 'USDT_IRT'
    }
  },
  created () {
    // this.getPrice()
  },
  methods: {
    // getPrice () {
    //   this.$store.dispatch('axios/get', { url: '/price?symbol=' + this.coin.symbol, config: { baseURL: process.env.BASE_EXCHANGE_URL } })
    //     .then((res) => {
    //       this.marketPrice = res.data.data.price
    //     }).catch((e) => {
    //       return e
    //     })
    // },
    open () {
      this.$refs.mySheet.open()
    }
  }
}
